import {
  CLONE_REASONS,
  RUN_AI_MODEL_MODES,
  type CloneReason,
  type RunAiModelMode,
} from "../MetadocConstants";

type RunAiModelHiddenReason =
  | "ops_post_ai"
  | "analyst_pre_ai"
  | "analyst_clone_reason_not_ai_analysis"
  | null;

export type RunAiModelContext = {
  mode: RunAiModelMode;
  hasPreAiRun: boolean;
  cloneReason: CloneReason | null;
};

export type RunAiModelDecision = {
  showRunAiModelButton: boolean;
  allowRunAiModelInAnalystMode: boolean;
  hiddenReason: RunAiModelHiddenReason;
};

/* decides run ai model visibility from mode + pre/post-ai + clone reason */
export const getRunAiModelDecision = (
  context: RunAiModelContext,
): RunAiModelDecision => {
  const { mode, hasPreAiRun, cloneReason } = context;

  if (mode === RUN_AI_MODEL_MODES.OPS) {
    if (hasPreAiRun) {
      return {
        showRunAiModelButton: false,
        allowRunAiModelInAnalystMode: false,
        hiddenReason: "ops_post_ai",
      };
    }

    return {
      showRunAiModelButton: true,
      allowRunAiModelInAnalystMode: false,
      hiddenReason: null,
    };
  }

  if (!hasPreAiRun) {
    return {
      showRunAiModelButton: false,
      allowRunAiModelInAnalystMode: false,
      hiddenReason: "analyst_pre_ai",
    };
  }

  if (cloneReason === CLONE_REASONS.AI_ANALYSIS) {
    return {
      showRunAiModelButton: true,
      allowRunAiModelInAnalystMode: true,
      hiddenReason: null,
    };
  }

  return {
    showRunAiModelButton: false,
    allowRunAiModelInAnalystMode: false,
    hiddenReason: "analyst_clone_reason_not_ai_analysis",
  };
};
